import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import en from './locales/en.json';
import ja from './locales/ja.json';
import {LocalStorage} from "@/common/storage.ts";
import {LANGUAGE_OPTION} from "@/constant/constants.ts";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en, // English translations
            },
            ja: {
                translation: ja, // Japanese translations
            },
        },
        lng: LocalStorage.getLang() || LANGUAGE_OPTION.ENGLISH,
        fallbackLng: LANGUAGE_OPTION.ENGLISH,
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;